module.exports = __webpack_public_path__ + "static/team-img6-e5ec9909cc33ef5d2e40865804a56f46.jpg";